<app-dialog-header label="Motius entrada" i18n-label></app-dialog-header>
<app-toolbar>
  <app-tool-button text="Editar" i18n-text (click)="this.dialogData.isReadOnly = false" color="has-color-green" icon="fa-edit" [disabled]="!this.auth.UserCanWrite(this.auth.Pages.GruaMotiusEntrada) || !this.dialogData.isReadOnly"></app-tool-button>
  <app-tool-button text="Guardar" i18n-text (click)="this.save()" color="has-color-green" icon="fa-save" [disabled]="!this.auth.UserCanWrite(this.auth.Pages.GruaMotiusEntrada) || this.dialogData.isReadOnly"></app-tool-button>
  <app-tool-button text="Eliminar" i18n-text (click)="this.remove();" color="has-color-red" icon="fa-trash-alt" [disabled]="!this.auth.UserCanDelete(this.auth.Pages.GruaMotiusEntrada) || this.dialogData.isReadOnly"></app-tool-button>
  <app-tool-button [text]="this.closeButtonText" i18n-text (click)="this.cancel()" color="has-color-yellow" icon="fa-th-list"></app-tool-button>
</app-toolbar>
<app-dialog-body>
  <form #mainForm>
    <div class="row">
      <app-form-text-edit id="grua-motius-entrada-editor-motiu"class="col-sm-11" i18n-label label="Motiu entrada" [(value)]="this.gruaMotiusEntrada.descripcio" required></app-form-text-edit>
    </div>
    <div class="row">
      <app-form-text-edit id="grua-motius-entrada-editor-avis"class="col-sm-11" i18n-label label="Avís usuari" [(value)]="this.gruaMotiusEntrada.avis"></app-form-text-edit>
    </div>
  </form>
</app-dialog-body>
